module.exports = __webpack_public_path__ + "static/edu-f23b7a62ed6856e99635287fa54032e9.png";